<template>
  <v-dialog v-model="dialog" persistent max-width="500px" :overlay="false">
    <v-card class="align-center text-lg-center pa-5">
      Encontramos uma conta com esse CPF, você será redirecionado ao login
      <v-card-actions class="text-center align-center justify-center mt-2">
        <v-btn color="primary" @click="$router.push({ name: 'Login' })">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: true
    }
  }
}
</script>

<style></style>
